import { Link as RouterLink } from "react-router-dom";
import { Box, CardContent, Link, useTheme } from "@mui/material";
import { ChartLineIcon, TableIcon, TextColumnsIcon, PushPinIcon } from "@phosphor-icons/react";
import { FilesToolIcon } from "~/assets/icons";
import CT from "~/components/ClampedTypography";
import InteractiveCard, { IconContainer } from "~/components/InteractiveCard";

interface TileProps {
  href: string;
  label: string;
  description: string;
  icon: string;
}

const DataBrowserTile = ({ href, label, description, icon }: TileProps) => {
  const theme = useTheme();
  const size = 24;
  const defaultColor = theme.palette.neutral[500];

  const renderIcon = () => {
    switch (icon) {
      case "files":
        return <FilesToolIcon color={defaultColor} width={size} height={size} />;
      case "dashboards":
        return <ChartLineIcon size={size} weight="bold" color={defaultColor} />;
      case "tables":
        return <TableIcon size={size} weight="fill" color={defaultColor} />;
      case "columns":
        return <TextColumnsIcon size={size} weight="bold" color={defaultColor} />;
      case "pins":
        return <PushPinIcon size={size} weight="fill" color={defaultColor} />;
      default:
        return null;
    }
  };

  return (
    <Link component={RouterLink} underline="none" to={href}>
      <InteractiveCard>
        <Box display="flex">
          <Box display="flex" alignItems="center" px={2}>
            <IconContainer
              sx={{
                backgroundColor: theme.palette.neutral[75],
                borderRadius: 1,
                width: 42,
                height: 42,
              }}
            >
              {renderIcon()}
            </IconContainer>
          </Box>
          <CardContent
            sx={{ gap: 0.5, minHeight: 82, p: 2, pl: 0, flex: 1, "&:last-child": { pb: 2 } }}
          >
            <CT variant="body1" fontWeight={600} lineHeight={1.2}>
              {label}
            </CT>
            <CT
              variant="body2"
              sx={{
                color: theme.palette.grey[700],
                display: "flex",
                flex: 1,
                flexDirection: "column",
                fontSize: 12,
                justifyContent: "flex-end",
                lineHeight: 1.3,
              }}
            >
              {description}
            </CT>
          </CardContent>
        </Box>
      </InteractiveCard>
    </Link>
  );
};

export default DataBrowserTile;
